import { TextField, TextFieldProps } from '@mui/material';
import { Controller, FieldError, useFormContext } from 'react-hook-form';

type Props = TextFieldProps & {
  name: string;
};

export function RHFTextField({ name, helperText, ...other }: Props) {
  const { control } = useFormContext();

  const parseError = (error: FieldError) => (Array.isArray(error) ? 'One or more items invalid' : error.message);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={''}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          autoComplete="off"
          fullWidth
          value={typeof field.value === 'number' && field.value === 0 ? '' : field.value}
          error={!!error}
          helperText={error ? parseError(error) : helperText}
          {...other}
        />
      )}
    />
  );
}
